import {
    FETCH_INSURANCES_REQUEST, FETCH_INSURANCES_SUCCESS, FETCH_INSURANCES_FAILURE,
    CREATE_INSURANCE_SUCCESS, UPDATE_INSURANCE_SUCCESS, DELETE_INSURANCE_SUCCESS
  } from "../actions/insuranceActions.js";
  
  const initialState = {
    insurances: [],
    loading: false,
    error: null,
  };
  
  export default function insuranceReducer(state = initialState, action) {
    switch (action.type) {
      case FETCH_INSURANCES_REQUEST:
        return { ...state, loading: true };
      case FETCH_INSURANCES_SUCCESS:
        return { ...state, loading: false, insurances: action.payload };
      case CREATE_INSURANCE_SUCCESS:
        return { ...state, insurances: [...state.insurances, action.payload] };
      case UPDATE_INSURANCE_SUCCESS:
        return {
          ...state,
          insurances: state.insurances.map((insurance) =>
            insurance.id === action.payload.id ? action.payload : insurance
          ),
        };
      case DELETE_INSURANCE_SUCCESS:
        return {
          ...state,
          insurances: state.insurances.filter((insurance) => insurance.id !== action.payload),
        };
      default:
        return state;
    }
  }
  